import { render, staticRenderFns } from "./ReviewBoardSave.vue?vue&type=template&id=3e160cd9&"
import script from "./ReviewBoardSave.vue?vue&type=script&lang=js&"
export * from "./ReviewBoardSave.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoardSave.vue?vue&type=style&index=0&id=3e160cd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports